<template>
  <el-dialog :title="isUpdate ? '编辑' : '添加资源 - 账户'" :visible="visible" width="900px" :destroy-on-close="true"
    :lock-scroll="false" @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :sm="12">
          <el-form-item label="登录账号:" prop="username">
            <el-input clearable :maxlength="20" v-model.trim="form.username" placeholder="请输入" :disabled="isUpdate" />
          </el-form-item>
          <el-form-item label="电子邮箱:" prop="email">
            <el-input clearable :maxlength="100" v-model.trim="form.email" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="手机号码:" prop="mobile">
            <el-input clearable :maxlength="11" v-model.trim="form.mobile" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="登录IP:">
            <el-input clearable :maxlength="200" v-model.trim="form.login_ip_str" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" @click="save" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import validate from 'ele-admin/packages/validate';

const defaultForm = () => ({
  id: undefined,
  status: 1,
  username: '',
  email: '',
  mobile: '',
  login_ip_str: '',
});

export default {
  name: 'FinanceEdit',
  props: {
    visible: Boolean,
    data: Object,
  },
  data() {
    return {
      form: defaultForm(),
      rules: {
        username: [{ required: true, message: '请输入', trigger: 'blur' }],
        email: [{ pattern: validate.email, message: '邮箱格式不正确', trigger: 'blur' }],
        mobile: [{ pattern: validate.phone, message: '手机号格式不正确', trigger: 'blur' }],
      },
      loading: false,
      isUpdate: false,
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        return;
      }
      this.$nextTick(() => {
        this.initForm();
      });
    },
  },
  methods: {
    initForm() {
      if (this.data && this.data.id) {
        this.form = {
          id: this.data.id,
          status: this.data.status || 1,
          username: this.data.username,
          email: this.data.email,
          mobile: this.data.mobile,
          login_ip_str: this.data.login_ip_str,
        };
        this.isUpdate = true;
      } else {
        this.form = defaultForm();
        this.isUpdate = false;
      }
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        this.$http.post('/finance/edit', {
          id: this.form.id,
          username: this.form.username,
          email: this.form.email,
          mobile: this.form.mobile,
          login_ip_str: this.form.login_ip_str,
          status: this.form.status || 1,
        }).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
  },
};
</script>
